import { css, cx, useTheme } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { getRatingResult, getRatingsRowCount } from '../../lib/utils'
import { Ref, forwardRef } from 'react'

interface Props {
  show?: boolean
  animate?: boolean
}

const Content = (
  { show = false, animate = true }: Props,
  ref: Ref<HTMLDivElement>
) => {
  const { colors } = useTheme()
  const [theme, stats] = useStats((s) => [s.theme, s.stats])
  const { ratings } = getRatingResult(stats)
  const rowCount = getRatingsRowCount(stats?.ratings?.top?.count || 0)

  return (
    <div
      ref={ref}
      className={cx(
        css`
          display: grid;
          grid-template-columns: repeat(${ratings.length}, 1fr);
          height: 100%;
          gap: 0 10px;
          position: relative;
          z-index: 1;
        `,
        'stats-ratings-grid-bars'
      )}
    >
      {ratings?.map((r, i) => {
        const progress = Math.round((r.count / rowCount) * 100)

        return (
          <div
            key={i}
            className={css`
              grid-row: 1 / ${rowCount + 1};
              border-radius: 6px;
              position: relative;
              overflow: hidden;
            `}
          >
            <span
              className={css`
                width: 1%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                border-right: 1px dashed ${colors.uiWhite20};
                opacity: 0.25;
              `}
            />
            <span
              className={css`
                display: block;
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
              `}
            />
            <span
              className={cx(
                css`
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  height: ${show ? `${progress}%` : '0%'};
                  background-color: ${theme.primary};
                  border-radius: 6px;
                  z-index: 3;
                `,
                animate
                  ? css`
                      transition: height 0.6s ease-out;
                    `
                  : '',
                'stats-ratings-grid-bar'
              )}
            />
          </div>
        )
      })}
    </div>
  )
}

export const RatingsGridBars = forwardRef(Content)
